<template>
    <div>
        <span class="prompt range">
            <em>Adjust the slider below to reflect your current view of yourself and your situation.</em><br>
            {{ question.question.body }}
        </span>
        <input type="range" :name="inputName" min="0" max="10" :list="tickmarksId" value="5">
        <datalist :id="tickmarksId">
            <option value="0" label="Strongly Agree">Strong Agree</option>
            <option value="1" />
            <option value="2" />
            <option value="3" />
            <option value="4" />
            <option value="5" label="Mildly Agree">Mildly Agree</option>
            <option value="6" />
            <option value="7" />
            <option value="8" />
            <option value="9" />
            <option value="10" label="Strongly Disagree">Strong Disgree</option>
        </datalist>
    </div>
</template>

<script>
export default {
    name: 'SurveyQuestionRange',
    props: [
        'question'
    ],
    data: function() {
        return {
            isValid: true
        }
    },
    computed: {
        inputName () {
            return 'question[' + this.question.id + '][' + this.question.cat + ']'
        },
        tickmarksId () {
            return 'tickmarks' + this.question.cat
        }
    }
}
</script>

<style lang="scss">
.question {
    input[type=range] {
        width: 100%;
    }

    datalist {
        display: flex;
        justify-content: space-between;
    }
}
</style>
